'use strict';

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearFormErrors(form) {
    $(form).find('.form-control.is-invalid').removeClass('is-invalid');
    $(form).find('.cc-form__group.cc-error').removeClass('cc-error');
    $(form).find('.js-form-error').empty();
}

export default function (formElement, payload) {
    // clear form validation first
    clearFormErrors(formElement);
    $('.alert', formElement).remove();

    if (typeof payload === 'object' && payload.fields) {
        Object.keys(payload.fields).forEach(function (key) {
            if (payload.fields[key]) {
                const $input = $(formElement).find('[name="' + key + '"]');
                const $formGroup = $input.closest('.cc-form__group');
                const $feedbackElement = $formGroup.find('.js-form-error');

                if ($feedbackElement.length > 0) {
                    const message = Array.isArray(payload.fields[key])
                        ? payload.fields[key].join('<br/>')
                        : payload.fields[key];

                    $feedbackElement.html(message);
                    $input.addClass('is-invalid');
                    $formGroup.addClass('cc-error');
                }
            }
        });
    }

    // scroll to first error
    const $firstError = $(formElement).find('.cc-error').first();
    const isInPopover = $(formElement).hasClass('cc-header__popover__form') || $(formElement).closest('.cc-header__popover').length > 0;

    if ($firstError.length > 0 && !isInPopover) {
        const headerHeight = $('.cc-header').height() + 30;
        const scrollAnimateOffset = $firstError.offset().top - headerHeight;

        $('html, body').animate({ scrollTop: scrollAnimateOffset }, 500);
    }

    // general error message
    if (payload && payload.error) {
        const form = $(formElement).prop('tagName') === 'FORM'
            ? $(formElement)
            : $(formElement).parents('form');
    }

    // remove error classes dynamically when user edits input
    $(document).on('input change', '.cc-error .form-control, .cc-error .selectpicker', function () {
        const $input = $(this);
        const $group = $input.closest('.cc-error');
        $group.removeClass('cc-error');
        $input.removeClass('is-invalid');
        $group.find('.js-form-error').empty();
    });
}